export enum Direction {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
